import { render, staticRenderFns } from "./pnlView.vue?vue&type=template&id=62f8fb26&scoped=true&lang=pug"
import script from "./pnlView.vue?vue&type=script&lang=js"
export * from "./pnlView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8fb26",
  null
  
)

export default component.exports